import i18n from '@/helpers/i18n'

export const YesNoList = {
  data() {
    return {
      yesNoList: [
        { text: i18n.instance().t('label-yesno-yes'), id: 1 },
        { text: i18n.instance().t('label-yesno-no'), id: 0 },
        { text: i18n.instance().t('label-yesno-doesnotknow'), id: 2 }
      ]
    }
  },
  computed: {
    yesNoChoices: function() {
      return this.yesNoList
    }
  },
  methods: {
    getYesNoLabelById: function(id) {
      return this.yesNoList.filter(x => x.id === id).first().text
    }
  }
}
